import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { cx } from './cx.js';
import { spinnerPhaseDelay } from './spinner.js';
export function LoadingState({ label = 'Loading', className }) {
    // In step with every other Trace spinner (spinnerPhaseDelay), so one replacing another never restarts the turn.
    const [spinDelay] = useState(() => spinnerPhaseDelay());
    return (_jsxs("div", { className: cx('trace-auth-loading', className), role: "status", "aria-live": "polite", "aria-busy": "true", children: [_jsx("span", { className: "trace-auth-spinner", style: { animationDelay: spinDelay }, "aria-hidden": "true" }), _jsx("span", { className: "trace-auth-loading__label", children: label })] }));
}
//# sourceMappingURL=LoadingState.js.map